/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');

/**
 * Ziggy
 */
import { route } from 'ziggy-js';
import { Ziggy } from './ziggy';

if (process.env.NODE_ENV != 'production') {
    // use dynamic url's for ziggy in dev, great for ngrok
    Ziggy.url = location.protocol+'//'+location.hostname;
}

window.route = route;
window.Ziggy = Ziggy;

/**
 * moment
 * Done here so local change is global, and on the window so Vue components can use it
 */
import moment from 'moment-timezone';
let momentDurationFormatSetup = require("moment-duration-format");

momentDurationFormatSetup(moment);
typeof moment.duration.fn.format === "function";
typeof moment.duration.format === "function";

moment.locale('en-gb');
moment.tz.setDefault(document.head.querySelector('meta[name="display-timezone"]').content)

window.moment = moment;

require('./bootstrap4-datetimepicker');

require('./vue');

require('./bootstrap-confirmation2');
require('./jqueryforall');
require('./modals');
require('./filters');

// remove any old service worker, thanks godaddy
if (navigator && navigator.serviceWorker && navigator.serviceWorker.getRegistration) {
  navigator.serviceWorker.getRegistration('/').then(function(registration) {
    if (registration) {
      registration.update();
      registration.unregister();
    }
  });
}
